export interface SelectPickerOptionProps {
  label: string;
  value: SelectPickerValue;
  isDisabled?: boolean;
}

export interface dateFormatOptionsProps {
  year?: 'numeric' | '2-digit';
  day?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
}

export type SelectPickerValue = string | number;

export type GenericObject = {
  [key: string]: any;
};

export type ValueOf<T> = T[keyof T];

export type GenericFunctionArgs = (...args: any[]) => void;

export const firebaseCollectionPaths = {
  agents: {
    path: 'agents',
    subCollections: {
      whatsAppChat: {
        path: 'chats'
      },
      customerSelfie: {
        path: 'customer-selfie'
      }
    }
  },
  cosmosSync: {
    path: 'tele-cosmos-sync'
  }
};

export const INVALID_DATE = 'Invalid Date';

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}
